/**
 * @format
 */

/**
 * Page type detector
 *
 * Cache the value of data-page-type in html tag so no need
 * to constantly query the DOM.
 *
 * All the boolean funcs to check page type are based
 * in get_page_type helper
 * defined in app/helpers/application_helper.rb
 */

const htmlNode = document.querySelector('[data-page-type]')
const pageType = htmlNode && htmlNode.dataset && htmlNode.dataset.pageType

export const currentPageType = {
  get: () => pageType,
  isPresent: () => pageType !== null,
  isDashboard: () => pageType === 'dashboard',
  isBookings: () => pageType === 'bookings',
  isBenefits: () => pageType === 'benefits',
  isGeneric: () => pageType === 'page',
  isPrivateHomePage: () => pageType === 'private_home_page',
  isProfilePage: () => pageType === 'profile_page',
  isHotelLandingPage: () => pageType === 'hotel_landing_page',
  isUserPrivateSectionPage: () => pageType === 'user_private_section_page',
  isHomePage: () => pageType === 'home_page',
  isOfferPage: () => pageType === 'offer_page',
  isDestinationPage: () => pageType === 'destination_page',
  isContactPage: () => pageType === 'contact_page',
  isPublicArea: () => pageType === 'public_area',
  isCheckInOnlinePage: () => pageType === 'check_in_online_page',
  isDestinationsIndex: () => pageType === 'destinations_index',
  isSpecialtiesIndex: () => pageType === 'specialties_index',
  isOffersIndex: () => pageType === 'offers_index',
}
